import request from '@/utils/request'


// 查询地址关键字列表
export function listAddressKeywordRestriction(query) {
  return request({
    url: '/order/address/keyword/restriction/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询地址关键字分页
export function pageAddressKeywordRestriction(query) {
  return request({
    url: '/order/address/keyword/restriction/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询地址关键字详细
export function getAddressKeywordRestriction(data) {
  return request({
    url: '/order/address/keyword/restriction/detail',
    method: 'get',
    params: data
  })
}

// 新增地址关键字
export function addAddressKeywordRestriction(data) {
  return request({
    url: '/order/address/keyword/restriction/add',
    method: 'post',
    data: data
  })
}

// 修改地址关键字
export function updateAddressKeywordRestriction(data) {
  return request({
    url: '/order/address/keyword/restriction/edit',
    method: 'post',
    data: data
  })
}

// 删除地址关键字
export function delAddressKeywordRestriction(data) {
  return request({
    url: '/order/address/keyword/restriction/delete',
    method: 'post',
    data: data
  })
}
